<template>
    <div :class="cardClass">
        <template v-if="!isLoading">
            <div class="RPLineGraphCard__header-bar">
                <span class="RPLineGraphCard__header">
                    <span class="RPLineGraphCard__header-text">
                        <slot name="header">{{ header }}</slot>
                    </span>
                    <LegendBar :legend="legend" />
                </span>
                <small class="RPLineGraphCard__info">
                    <slot name="info">{{ headerInfo }}</slot>
                </small>
            </div>
            <div class="RPLineGraphCard__chart-container">
                <ApexCharts
                    :series="graphData"
                    :options="options"
                    height="100%"
                />
            </div>
        </template>
    </div>
</template>
<script>
import LegendBar from './RPMultiLineGraph/LegendBar.vue';
import ApexCharts from 'vue-apexcharts';
import stat from 'status';
import statusBuilder from 'status/statusBuilder';
import has from 'lodash/has';
import getRandomColor from '../getRandomColor';

export default {
    name: 'RPLineGraphCard',
    components: {
        LegendBar,
        ApexCharts
    },
    props: {
        header: {
            type: String,
            default: ''
        },
        headerInfo: {
            type: String,
            default: 'Info'
        },
        graphData: {
            type: Array,
            required: true,
        },
        status: {
            type: String,
            default: stat.STANDBY,
        }
    },
    computed: {
        isLoading(){
            return this.status === stat.LOADING;
        },
        cardClass(){
            return statusBuilder('RPLineGraphCard', this.status);
        },
        legend(){
            return this.graphData.map(d => ({
                name: d.name,
                color: has(d, 'color') ? d.color : getRandomColor(JSON.stringify(d)),
            }));
        },
        options(){
            return {
                chart: {
                    type: 'line',
                    animations: {
                        enabled: false,
                    },
                    toolbar: {
                        show: false
                    }
                },
                colors: this.graphData.map(d => has(d, 'color') ? d.color : getRandomColor(JSON.stringify(d))),
                xaxis: {
                    type: "datetime",
                    tooltip: {
                        enabled: false
                    }
                },
                markers: {
                    size: 4,
                    strokeWidth: 0,
                    strokeDashArray: 0,
                },
                stroke: {
                    width: 2,
                    curve: 'smooth'
                },
                tooltip: {
                    followCursor: true,
                    x: {
                        show: false
                    }
                },
                legend: {
                    show: false,
                }
            };
        }
    },
};
</script>
<style lang="scss">
    .RPLineGraphCard {
        position: relative;
        border-radius: 4px;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08);
        padding: 1rem;
        background: $white;

        @include loading(100%, 100%);

        &__header {
            display: flex;
            align-items: center;
            &-text {
                margin-right: 1rem;
                font-weight: 600
            }
        }
        &__info {
            color: $text-grey
        }
        &__chart-container {
            position:absolute;
            bottom: 1rem;
            top: 5rem;
            left: 1rem;
            right: 1rem;
        }
    }
</style>
